import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Agenda from "@/pages/Agenda";
import Memberships from "@/pages/Memberships";
import Services from "@/pages/Services";
import Sales from "@/pages/Sales";
import Marketing from "@/pages/Marketing";
import Settings from "@/pages/Settings";
import Login from "@/pages/Login";
import PublicCatalog from "@/pages/PublicCatalog";
import { Toaster } from "@/components/ui/sonner";

function RootRedirect() {
  const { user } = useAuth();
  if (user === undefined) return null;
  return user ? <Dashboard /> : <Navigate to="/catalogo" replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/catalogo" element={<PublicCatalog />} />
            <Route path="/login" element={<Login />} />

            {/* Protected routes with layout */}
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<RootRedirect />} />
              <Route path="/clientes" element={<Clients />} />
              <Route path="/agenda" element={<Agenda />} />
              <Route path="/membresias" element={<Memberships />} />
              <Route path="/servicios" element={<Services />} />
              <Route path="/ventas" element={<Sales />} />
              <Route path="/marketing" element={<Marketing />} />
              <Route path="/ajustes" element={<Settings />} />
            </Route>

            <Route path="*" element={<Navigate to="/catalogo" replace />} />
          </Routes>
        </AuthProvider>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
